import {Component, OnInit, Input} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {
    @Input() heading: string;
    @Input() icon: string;
    @Input() parent: string = 'Dashboard';
    @Input() routerLink: string = "['/dashboard']";
    link: any;
    constructor(private router: Router) {}

    ngOnInit() {

    }
    OnPaheHeaderLinkClick() {
        this.link = this.router.url.split('/');
        this.routerLink = "['/" + this.link[1].toString() + "']";
        this.router.navigate(['/' + this.link[1]]);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2455195120/src/src/app/shared/modules/page-header/page-header.component.ts